export default "__VITE_ASSET__BqfRDbN1__"